// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__N0EZs","rightDecor":"Contact_rightDecor__P5Crg","leftDecor":"Contact_leftDecor__TEWis","contactContainer":"Contact_contactContainer__Q-rbO"};